import dayjs from "dayjs";

import { MdCopyright } from "react-icons/md";

import { useCurrentAccount } from "@/hooks/useCurrentAccount";

import { ReportHeader } from "@/components/Generics/ReportHeader";

import "./style.css";

type Props = {
	header?: React.ReactNode;
	headerContainer?: React.ReactNode;
	children?: React.ReactNode;
	footer?: React.ReactNode;
	displayCurrentDate?: boolean;
	printComponentRef?: React.MutableRefObject<HTMLDivElement | null>;
};

export function PrintComponent({ header, children, printComponentRef, headerContainer }: Props) {
	const { currentAccount } = useCurrentAccount();

	return (
		<div ref={printComponentRef}>
			<div className="print-container">
				<section>
					{currentAccount.locale ? <ReportHeader city={currentAccount.locale} /> : <></>}
					{header}
				</section>
				<section className="print-container pt-10">{headerContainer}</section>
				<section className="print-container my-2 mx-10 text-end">
					<p>Data da exportação: {dayjs().format("DD/MM/YYYY HH:mm")}</p>
				</section>
			</div>
			<section>{children}</section>
			<section className="w-100 print-container">
				<div className="w-100 bg-secondary" style={{ position: "fixed", bottom: 0 }}>
					<p className="mb-0 d-flex align-items-center gap-2 text-center p-2">
						<MdCopyright /> Multintegrada tecnologia
					</p>
				</div>
			</section>
		</div>
	);
}
